import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/pyramidbet/images/logoMb.png';

export default function Index() {
  return <Image src={logo} maxW="100px" />;
}
